import 'rxjs/add/operator/map';
import {DOCUMENT} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {Component, Inject, OnInit} from '@angular/core';
import {ApiServiceService} from '../../api-service.service';
import {AnalyticsTracker} from '../../utils/AnalyticsTracker';
import {UserInteractor} from '../../interactors/user.interactor';
import {Keys, StorageService} from '../../service/storage.service';
import {LoanApplication} from '../../model/loan-application.model';
import {EnumValues} from 'enum-values';
import {LoanReason} from '../../model/loan-reason';
import {LoanTenure} from '../../model/loan-tenure';
import {isEmpty} from 'lodash';
import {Tracker} from '../../utils/tracker';
import {ConfigService} from '../../service/config.service';

@Component({
    selector: 'app-home',
    styleUrls: ['./home.component.css'],
    templateUrl: './home.component.html',
    providers: [ApiServiceService, UserInteractor]
})
export class HomeComponent implements OnInit {
    schemaData = `{
      "@id": "https://finzy.com/#organization",
      "@context": "http://schema.org",
      "@type": "Organization",
      "name": "finzy",
      "description": "A digital platform that connects borrowers looking for personal loans with Investors looking to invest in an asset class with risk optimised returns. Finzy provides you quick personal loans at low-interest rates.",
      "logo": "https://res.cloudinary.com/finzy/image/upload/v1534503733/finzy-logo-1x1_dyqago.png",
      "url": "https://finzy.com/borrow",
      "telephone": "+91 9341 300 300",
      "legalName": "Bridge Fintech Solutions Private Limited",
      "foundingDate": "6 October 2016",
      "founders": [
        {
          "@type": "Person",
          "name": "Amit More"
        },
        {
          "@type": "Person",
          "name": "Abhinandan Sangam"
        },
        {
          "@type": "Person",
          "name": "Vishwas Dixit"
        }
      ],
      "address": {
        "@type": "PostalAddress",
        "streetAddress": " 118, 1st Floor, 80 Feet Road",
        "addressLocality": "Koramangala 7th Block",
        "addressRegion": "Bengaluru",
        "postalCode": "560095",
        "addressCountry": "India"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Support",
        "telephone": "[+91-9341-300-300]",
        "email": "support@finzy.com"
      },
      "sameAs": [
        "https://www.facebook.com/finzyindia",
        "https://www.linkedin.com/company/finzy",
        "https://www.instagram.com/finzyindia/",
        "https://twitter.com/finzyindia"
      ]
    }`;

    loanpurposes: any;
    loanTenures: LoanTenure[];
    errorMsgRange: boolean;
    errorMsgMult: boolean;
    errorMsgPurpose = false;
    errorMsgLoan = false;
    public loanamt: any;
    public loanpurpose: any;
    loanTenure: LoanTenure;
    d1 = true;
    d1h = false;
    d2 = true;
    d2h = false;
    d3 = true;
    d3h = false;
    d4 = true;
    d4h = false;
    finzyDomain = true;
    otherDomain = false;
    partnerLogoUrl: string;
    errorMsgTenure: boolean;
    minimumLoanAmount: number;

    constructor(private httpClient: HttpClient, private router: Router, private ref: ApiServiceService,
                private storageService: StorageService, public dialog: MatDialog, private route: ActivatedRoute,
                @Inject(DOCUMENT) private document: any, public analyticsTracker: AnalyticsTracker,
                private readonly userInteractor: UserInteractor, public tracker: Tracker, private configService: ConfigService) {
        this.errorMsgTenure = false;
    }


    over1() {
        this.d1 = false;
        this.d1h = true;
    }

    out1() {
        this.d1 = true;
        this.d1h = false;
    }

    over2() {
        this.d2 = false;
        this.d2h = true;
    }

    out2() {
        this.d2 = true;
        this.d2h = false;
    }

    over3() {
        this.d3 = false;
        this.d3h = true;
    }

    out3() {
        this.d3 = true;
        this.d3h = false;
    }

    over4() {
        this.d4 = false;
        this.d4h = true;
    }

    out4() {
        this.d4 = true;
        this.d4h = false;
    }

    loanPurposeChange(event) {
        this.errorMsgPurpose = false;
        return false;
    }

    loanTenureChange() {
        this.errorMsgTenure = false;
    }

    cibilCheckClick() {
        this.router.navigate(['cibil/check-user-details']);
    }

    async submitForm(formdata) {
        this.errorMsgRange = false;
        this.errorMsgMult = false;
        this.errorMsgPurpose = false;
        this.errorMsgLoan = false;
        if (!formdata.loanamt || !formdata.loanpurpose || !formdata.loanTenure) {
            if (!formdata.loanamt) {
                this.errorMsgLoan = true;
            }
            if (!formdata.loanpurpose) {
                this.errorMsgPurpose = true;
            }
            if (!formdata.loanTenure) {
                this.errorMsgTenure = true;
            }
        } else {
            if ((formdata.loanamt % 1000 == 0) && (formdata.loanamt != 0)) {
                if ((formdata.loanamt >= this.minimumLoanAmount) && (formdata.loanamt < 500001)) {
                    this.errorMsgPurpose = false;
                    this.errorMsgLoan = false;
                    this.errorMsgTenure = false;
                    const userId = await this.userInteractor.getUserId();
                    const channelPartnerId = await this.storageService.getObjectFromSession<string>(Keys.PARTNER_ID);
                    this.storageService.saveObject(Keys.LOAN_APPLICATION, new LoanApplication(Number(formdata.loanamt), formdata.loanpurpose, userId, formdata.loanTenure, channelPartnerId));
                    this.storageService.saveItem(Keys.LOAN_TENURE, formdata.loanTenure);
                    this.router.navigate(['borrow/intro']);
                } else {
                    this.errorMsgRange = true;
                }
            } else {
                this.errorMsgRange = true;
            }
        }
    }

    onKey(event: any) {
        this.errorMsgLoan = false;
        if (event.target.value >= this.minimumLoanAmount && event.target.value < 500001) {
            if (event.target.value % 1000 == 0) {
                this.errorMsgRange = false;
                this.errorMsgMult = false;
                return false;
            } else {
                this.errorMsgRange = false;
                this.errorMsgMult = true;
                return false;
            }
        } else {
            this.errorMsgRange = true;
            this.errorMsgMult = false;
            return false;
        }
    }

    async ngOnInit() {
        await this.setMinimumLoanAmount();
        this.route.data.subscribe(data => {
            this.partnerLogoUrl = data.partnerLogoUrl;
        });
        this.dialog.closeAll();
        this.loanpurposes = EnumValues.getValues(LoanReason);
        this.loanTenures = EnumValues.getValues(LoanTenure);
    }

    protected async setMinimumLoanAmount(): Promise<void> {
        const channelPartnerId = await this.storageService.getObjectFromSession<string>(Keys.PARTNER_ID);
        this.minimumLoanAmount = isEmpty(channelPartnerId) ? this.configService.getMinimumLoanAmount() :
            this.configService.getMinimumLoanAmountForPartner();
    }
}
